import { render, staticRenderFns } from "./health-record-detail.vue?vue&type=template&id=caece3f6&scoped=true"
import script from "./health-record-detail.vue?vue&type=script&lang=js"
export * from "./health-record-detail.vue?vue&type=script&lang=js"
import style0 from "./health-record-detail.vue?vue&type=style&index=0&id=caece3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caece3f6",
  null
  
)

export default component.exports